import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import {
  PlanejamentoOrcamentarioDetalheResponse,
  FiltroPrevisaoOrcamentaria,
} from "../typings";

export default function usePrevisaoOrcamentariaDetalhe(
  id?: string,
  query?: FiltroPrevisaoOrcamentaria
) {
  return useQuery<PlanejamentoOrcamentarioDetalheResponse, AxiosError>(
    [`/v1/previsao-orcamentaria/${id}`, query],
    async () => {
      const { data } = await http.get<PlanejamentoOrcamentarioDetalheResponse>(
        `/v1/previsao-orcamentaria/${id}`,
        {
          params: query,
        }
      );

      return data;
    },
    {
      enabled: !!id,
    }
  );
}
